var render, staticRenderFns
import script from "./PermissionPage.vue?vue&type=script&lang=js&"
export * from "./PermissionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc8e0c4')) {
      api.createRecord('6dc8e0c4', component.options)
    } else {
      api.reload('6dc8e0c4', component.options)
    }
    
  }
}
component.options.__file = "src/components/Page/PermissionPage.vue"
export default component.exports